/** Company letter accents — excludes radar score colors (green, red, yellow). */
const LETTER_ACCENT_COLORS = [
  '#60a5fa', // blue
  '#f472b6', // pink
  '#a78bfa', // purple
  '#fb923c', // orange
  '#38bdf8', // sky
  '#818cf8', // indigo
  '#e879f9', // fuchsia
  '#c084fc', // violet
];

export function getLetterColor(letter: string): string {
  const colors = LETTER_ACCENT_COLORS;
  return colors[letter.charCodeAt(0) % colors.length];
}

export function hexToRgb(hex: string): string {
  const h = hex.replace('#', '');
  return `${parseInt(h.substring(0, 2), 16)}, ${parseInt(h.substring(2, 4), 16)}, ${parseInt(h.substring(4, 6), 16)}`;
}
